<template>
    <button v-on:click="renew" class="btn btn-primary btn-lg my-3">つぎの もんだいへ</button>
</template>

<script>
export default {
    name: 'TryAgainButton',
    props: ['renew']
}
</script>